// Tours booked on WhatsApp only (no online deposit)
export default {
  whatsappOnly: {
    badge: 'Réservation par WhatsApp',
    note: 'Cette excursion se réserve directement auprès de notre équipe sur WhatsApp. Nous confirmons la disponibilité et convenons du paiement avec vous — aucun paiement anticipé sur le site.',
    reserve: 'Réserver sur WhatsApp',
    secure: 'Aucun paiement sur le site : notre équipe confirme tout avec vous sur WhatsApp.',
    cartNote: 'Cette commande est confirmée sur WhatsApp : notre équipe vérifie la disponibilité et convient du paiement avec vous.',
    cartMixed: 'Votre panier contient des excursions réservables uniquement sur WhatsApp ; toute la commande sera donc confirmée là-bas.',
    stepConfirm: 'WhatsApp',
    formLead: 'Renseignez vos coordonnées et nous enverrons la réservation complète à notre équipe sur WhatsApp.',
    submit: 'Confirmer la réservation sur WhatsApp',
    submitHint: 'WhatsApp s’ouvre avec l’excursion, la date, les participants et vos coordonnées déjà renseignés.',
  },
};
